webpackJsonp([7],{

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(787)
}
var Component = __webpack_require__(99)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(771),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/builds/infosecau/seccsrcapp/src/pages/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-515264ec", Component.options)
  } else {
    hotAPI.reload("data-v-515264ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  data: function data() {
    return {
      locale: localStorage.locale
    };
  },

  mounted: function mounted() {
    function skyCanvas() {
      function t(t, i) {
        if (arguments.length < 2 && (i = t, t = 0), t > i) {
          var s = i;
          i = t, t = s;
        }
        return Math.floor(Math.random() * (i - t + 1)) + t;
      }
      function i(t, i) {
        var s = Math.max(t, i),
            a = Math.round(Math.sqrt(s * s + s * s));
        return a / 2;
      }
      function s() {
        var t = new Image();
        t.src = "/static/img/star.jpg", t.onload = function () {
          n.drawImage(t, 0, 0), window.requestAnimationFrame(s);
        }, n.drawImage(t, 0, 0);
        for (var i = 1, a = r.length; a > i; i++) {
          r[i].draw();
        }
      }
      var a = document.getElementById("canvas"),
          n = a.getContext("2d"),
          o = a.width = $(".banner").width(),
          e = a.height = $(".banner").height(),
          r = [],
          c = 0,
          d = 300,
          l = document.createElement("canvas"),
          h = l.getContext("2d");
      l.width = 100, l.height = 100;
      var m = l.width / 2,
          f = h.createRadialGradient(m, m, 3, m, m, 26);
      f.addColorStop(.025, "#87c0f6"), f.addColorStop(.25, "#11417a"), f.addColorStop(1, "transparent"), h.fillStyle = f, h.beginPath(), h.arc(m, m, m, 0, 2 * Math.PI), h.fill();
      var u = function u() {
        this.orbitRadius = t(i(o, e)), this.radius = t(60, this.orbitRadius) / 12, this.orbitX = o / 2, this.orbitY = e / 2, this.timePassed = t(0, d), this.speed = t(this.orbitRadius) / 9e5, this.alpha = t(2, 10) / 10, c++, r[c] = this;
      };
      u.prototype.draw = function () {
        var i = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
            s = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
            a = t(10);
        1 === a && this.alpha > 0 ? this.alpha -= .05 : 2 === a && this.alpha < 1 && (this.alpha += .05), n.globalAlpha = this.alpha, n.drawImage(l, i - this.radius / 2, s - this.radius / 2, this.radius, this.radius), this.timePassed += this.speed;
      };
      for (var p = 0; d > p; p++) {
        new u();
      }s();
    }
    skyCanvas();
  },
  computed: {
    vulnImg: function vulnImg() {
      return this.$t('message.vuln.img');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(151)))

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(149)(false);
// imports


// module
exports.push([module.i, "\n.banner {  width: 100%;  height: 220px; background-image: url(/static/img/bg.jpg);  background-position: top center;  background-size: cover;  color: #fff;  text-align: center;  text-shadow: 0 0 3px rgba(0, 0, 0, .5); overflow: hidden;position: relative\n}\n.banner h2 {  font-size: 22px; opacity: .95;margin-bottom: 0;margin-top: 25px;\n}\n.banner h6 {  font-size: 14px; line-height: 1.4;  padding: 10px 0;  font-weight: normal;margin-top: 0\n}\n.banner a {  padding: 6px 15px; border: 1px solid #fff;  border-radius: 3px;  color: #fff; text-decoration: none; font-size: 14px;\n}\n.index-area {padding: 20px 0;\n}\n.index-area h2 {font-size: 22px;\n}\n.index-area p {font-weight: normal;  font-size: 14px;text-align: left;line-height: 1.6;\n}\n.about { background: #f2f2f2;\n}\n.vulnerability {background: #fff;\n}\n.vulnerability img{margin-top: 20px;\n}\n.about{margin-top: 20px;\n}\n.banner .blue-btn {\n  background: #0071e3;\n  border: 0;\n  border-radius: 20px;\n  padding: 10px 30px;\n}\n.banner .blue-btn:hover {\n  background: #0077ED;\n}\n\n/* 平板，大于768 */\n@media (min-width: 768px) {\n.banner {height: 400px;\n}\n.banner h2 {  font-size: 40px;margin-top: 100px;\n}\n.banner h6 {  font-size: 28px;\n}\n.banner a{font-size: 18px;\n}\n.index-area h2 {font-size: 40px;margin-bottom: 20px;\n}\n.index-area p{font-size: 16px;\n}\n}\n/* 桌面显示器，大于992 */\n@media (min-width: 992px) {\n}\n/* 桌面显示器，大于1200 */\n@media (min-width: 1200px) {\n.banner {width: 100%; height: 600px; background-position: top center;  background-size: cover;  color: #fff; text-align: center; text-shadow: 0 0 3px rgba(0, 0, 0, .5);\n}\n.banner h2 {font-size: 60px; opacity: .95;margin-top: 150px;\n}\n.banner h6 {font-size: 30px; line-height: 1.4; padding: 20px 50px; font-weight: normal;\n}\n.banner a {padding: 6px 15px; border: 1px solid #fff; border-radius: 3px; color: #fff; text-decoration: none; font-size: 18px;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('canvas', {
    staticClass: "canvas",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-area clearfix"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("message.title")))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t("message.banner")))]), _vm._v(" "), _c('router-link', {
    staticClass: "blue-btn",
    attrs: {
      "to": "/Report"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.bannerButtonTxt")))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "index-area vulnerability"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("message.vuln.title")))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.vuln.text'))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.vulnImg
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-515264ec", module.exports)
  }
}

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(756);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(150)("3a541690", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-515264ec\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-515264ec\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7_c1bd15b7d8aed90e2bfc.js